<template>
  <div class="filters-sector">
    <div class="filters-sector__title">
      {{ $t('sector.title') }}
    </div>
    <ui-checkbox
      class="filters-sector__checkbox"
      :id="`sector-${index}`"
      v-for="(s, index) in sectorObj"
      :key="`sector ${index}`"
      v-model="model"
      :value="s.name"
      :disabled="disabledIfNotSameLevel(s)"
    >
      <span class="filters-sector__checkbox__label">
        <span class="filters-sector__checkbox__label__name"> {{ s.name }}</span>
        <span class="filters-sector__checkbox__label__level">{{ $t('sector.level') }} {{ s.level }} </span>
      </span>
    </ui-checkbox>
  </div>
</template>

<script>
import UiCheckbox from '@/components/UI/Checkbox.vue'
import { mapState } from 'vuex'

export default {
  name: 'FilterSector',
  components: {
    UiCheckbox,
  },
  props: {
    sectorObj: {
      type: Array,
      required: true,
    },
    currentSectors: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState({
      settings: state => state.data.settings,
      currentKpi: state => state.refine.currentKpi,
    }),
    model: {
      get() {
        return this.currentSectors
      },
      set(array) {
        this.$emit('update', array)
      },
    },
    computedSettings() {
      return this.settings.filter(setting => setting.key === this.currentKpi)[0]
    },
  },
  methods: {
    disabledIfNotSameLevel(sector) {
      if (this.currentSectors.length > 0) {
        const sectors = this.computedSettings?.sectors.filter(s => this.currentSectors.includes(s.name))
        return sector.level !== sectors[0].level
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
.filters-sector {
  &__title {
    @include sub-title;
  }

  &__checkbox {
    margin-bottom: 10px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }

    &__label {
      display: grid;
      grid-template-columns: auto 60px;
      grid-template-rows: 1fr;
      align-items: center;

      &__name {
        margin-right: auto;
      }

      &__level {
        font-size: 0.8rem;
      }
    }
  }
}
</style>
